var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "First Date Timezone" },
          model: {
            value: _vm.clone.isAfter.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isAfter, "fromTimezone", $$v)
            },
            expression: "clone.isAfter.fromTimezone",
          },
        }),
        _vm._v(" "),
        _c("TimezonePickerInput", {
          attrs: { title: "Second Date Timezone" },
          model: {
            value: _vm.clone.isAfter.toTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isAfter, "toTimezone", $$v)
            },
            expression: "clone.isAfter.toTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "First Date Format" },
          model: {
            value: _vm.clone.isAfter.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isAfter, "fromFormat", $$v)
            },
            expression: "clone.isAfter.fromFormat",
          },
        }),
        _vm._v(" "),
        _c("FormatPickerInput", {
          attrs: { title: "Second Date Format" },
          model: {
            value: _vm.clone.isAfter.toFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isAfter, "toFormat", $$v)
            },
            expression: "clone.isAfter.toFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "First Date Locale" },
          model: {
            value: _vm.clone.isAfter.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isAfter, "fromLocale", $$v)
            },
            expression: "clone.isAfter.fromLocale",
          },
        }),
        _vm._v(" "),
        _c("LocalePickerInput", {
          attrs: { title: "Second Date Locale" },
          model: {
            value: _vm.clone.isAfter.toLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isAfter, "toLocale", $$v)
            },
            expression: "clone.isAfter.toLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }